import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/HowMuchWillItCostCalculator.jpg";
import HowMuchWillItCostCalculator from "../../frontend/components/calculators/HowMuchWillItCostCalculator";

const HowMuchWillItCostPage = () => {
  return (
    <div>
      <Hero
        title="How Much Will It Cost"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <HowMuchWillItCostCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default HowMuchWillItCostPage;
